import { post, type RequestConfig } from "../shared/api-client";
import { JIVANDHARA_BASE } from "../admin/list-api-helpers";
import type {
  ItemDonationPayload,
  ScrapDonationPayload,
} from "@project/types/item-donation";

const SILENT: RequestConfig = { showNotification: false };

class PublicItemDonationService {
  submit = (payload: ItemDonationPayload) =>
    post<unknown, ItemDonationPayload>(
      `${JIVANDHARA_BASE}/item-donations/`,
      payload,
      SILENT
    );

  submitScrap = (payload: ScrapDonationPayload) => {
    const formData = new FormData();
    formData.append("full_name", payload.full_name);
    formData.append("mobile_number", payload.mobile_number);
    if (payload.email?.trim()) {
      formData.append("email", payload.email.trim());
    }
    formData.append("item_category", String(payload.item_category));
    formData.append("item_name", payload.item_name);
    formData.append("quantity", String(payload.quantity));
    formData.append("item_condition", payload.item_condition);
    formData.append("pickup_address", payload.pickup_address);
    formData.append("area", payload.area);
    if (payload.landmark?.trim()) {
      formData.append("landmark", payload.landmark.trim());
    }
    formData.append("pincode", payload.pincode);
    if (payload.message?.trim()) {
      formData.append("message", payload.message.trim());
    }
    if (payload.photo) {
      formData.append("photo", payload.photo);
    }

    return post<unknown, FormData>(
      `${JIVANDHARA_BASE}/scrap-donations/`,
      formData,
      {
        ...SILENT,
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  };
}

export const publicItemDonationService = new PublicItemDonationService();
